import { CalendarIcon, ClockIcon } from "@xola/icons";
import { DateFormat, formatDate } from "common";
import { Dayjs } from "dayjs";
import React from "react";
import { Experience, PurchaseItem } from "types";
import { useResource } from "../../../hooks/useResource";
import { NoTranslate } from "../../Common/NoTranslate";
import { ProductImage } from "../../Common/ProductImage";

interface ExperienceTileProps {
    item: PurchaseItem;
    experienceId: string;
    arrivalDateTime: Dayjs;
    showTime?: boolean;
}

export const ExperienceTile = ({ item, experienceId, arrivalDateTime, showTime }: ExperienceTileProps) => {
    const hasTime = showTime ?? "arrivalTime" in item;
    const { data: product } = useResource<Experience>(["products", experienceId]);
    return (
        <div className="flex flex-row">
            <ProductImage product={{ id: experienceId }} size="small" className="mr-1" />
            <div className="flex flex-col justify-between py-1">
                <NoTranslate
                    as="div"
                    className="!whitespace-normal pb-1 font-bold"
                    data-testid="switch-experience-timeline-item-product-name"
                >
                    {product?.name}
                </NoTranslate>
                <div className="flex space-x-1.5">
                    <span className="flex items-center space-x-1">
                        <CalendarIcon />
                        <span data-testid="banner-arrival-date">{formatDate(arrivalDateTime, DateFormat.DATE)}</span>
                    </span>
                    {hasTime ? (
                        <span className="flex items-center space-x-1 pr-1">
                            <ClockIcon />
                            <span data-testid="banner-arrival-time">
                                {formatDate(arrivalDateTime, DateFormat.TIME)}
                            </span>
                        </span>
                    ) : null}
                </div>
            </div>
        </div>
    );
};
